import { TypedRouteLocationDTO } from '../../dto/TypedRouteLocationDTO';

export class RouteDTO {
    constructor(
        public id: number,
        public code: string,
        public locations: TypedRouteLocationDTO[]
    ) {}
}
